// MindMate frontend - LoginPage.js
import React from 'react';
import Login from '../components/Login';
import './Auth.css'; 

const LoginPage = () => {
  return <Login />;
};

export default LoginPage;
